var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesBgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 120,
    viewBox: "0 0 135 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.785 60.8145C135.81 27.8009 93.0084 6.51584 67.3544 0H127C131.418 0 135 3.58172 135 8V112C135 116.418 131.418 120 127 120H-25C3.08439 114.027 67.7595 93.8281 101.785 60.8145Z",
    fill: "white",
    fillOpacity: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBgDark);
export default __webpack_public_path__ + "static/media/servicesBgDark.eebb0585f40fa8a6d8e718baa355c15c.svg";
export { ForwardRef as ReactComponent };